import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Move({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Move.Outline {...props} /> : <Move.Solid {...props} />;
}

Move.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          className="icon-outline"
          d="M17 7C15.8954 7 15 6.10457 15 5C15 3.89543 15.8954 3 17 3C18.1046 3 19 3.89543 19 5C19 6.10457 18.1046 7 17 7Z"
          fill="currentColor"
        />
        <path
          className="icon-outline"
          d="M17 14C15.8954 14 15 13.1046 15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12C19 13.1046 18.1046 14 17 14Z"
          fill="currentColor"
        />
        <path
          className="icon-outline"
          d="M15 19C15 20.1046 15.8954 21 17 21C18.1046 21 19 20.1046 19 19C19 17.8954 18.1046 17 17 17C15.8954 17 15 17.8954 15 19Z"
          fill="currentColor"
        />
        <path
          className="icon-outline"
          d="M7 7C5.89543 7 5 6.10457 5 5C5 3.89543 5.89543 3 7 3C8.10457 3 9 3.89543 9 5C9 6.10457 8.10457 7 7 7Z"
          fill="currentColor"
        />
        <path
          className="icon-outline"
          d="M7 14C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12C9 13.1046 8.10457 14 7 14Z"
          fill="currentColor"
        />
        <path
          className="icon-outline"
          d="M5 19C5 20.1046 5.89543 21 7 21C8.10457 21 9 20.1046 9 19C9 17.8954 8.10457 17 7 17C5.89543 17 5 17.8954 5 19Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Move.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          className="icon-primary"
          d="M17 7C15.8954 7 15 6.10457 15 5C15 3.89543 15.8954 3 17 3C18.1046 3 19 3.89543 19 5C19 6.10457 18.1046 7 17 7Z"
          fill="currentColor"
        />
        <path
          className="icon-primary"
          d="M17 14C15.8954 14 15 13.1046 15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12C19 13.1046 18.1046 14 17 14Z"
          fill="currentColor"
        />
        <path
          className="icon-primary"
          d="M15 19C15 20.1046 15.8954 21 17 21C18.1046 21 19 20.1046 19 19C19 17.8954 18.1046 17 17 17C15.8954 17 15 17.8954 15 19Z"
          fill="currentColor"
        />
        <path
          className="icon-primary"
          d="M7 7C5.89543 7 5 6.10457 5 5C5 3.89543 5.89543 3 7 3C8.10457 3 9 3.89543 9 5C9 6.10457 8.10457 7 7 7Z"
          fill="currentColor"
        />
        <path
          className="icon-primary"
          d="M7 14C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12C9 13.1046 8.10457 14 7 14Z"
          fill="currentColor"
        />
        <path
          className="icon-primary"
          d="M5 19C5 20.1046 5.89543 21 7 21C8.10457 21 9 20.1046 9 19C9 17.8954 8.10457 17 7 17C5.89543 17 5 17.8954 5 19Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
